window.themegoal = window.themegoal || {};
window.themegoal.productZoom = window.themegoal.productZoom || {};

document.querySelectorAll('section-product').forEach(function (section) {
  var settings;

  try {
    settings = JSON.parse(section.getAttribute('data-section-settings') || '{}');
  } catch (e) {
    return;
  }

  if (!settings.enableImageZoom || !settings.zoomMedia || !settings.zoomMedia.length) {
    return;
  }

  var sectionId = section.getAttribute('data-section-id');
  var zoomMedia = settings.zoomMedia;
  var lightbox = null;

  window.themegoal.productZoom[sectionId] = {
    open: function (mediaId) {
      var index = zoomMedia.findIndex(function (media) {
        return String(media.id) === String(mediaId);
      });

      if (index === -1) {
        return;
      }

      var dataSource = zoomMedia.map(function (media) {
        return { src: media.src, width: media.width, height: media.height, alt: media.alt };
      });

      if (lightbox) {
        lightbox.loadAndOpen(index, dataSource);
        return;
      }

      import(settings.pswpLightboxUrl).then(function (module) {
        var PhotoSwipeLightbox = module.default;

        lightbox = new PhotoSwipeLightbox({
          pswpModule: function () {
            return import(settings.pswpCoreUrl);
          },
          bgOpacity: 0.9,
          wheelToZoom: true,
          padding: { top: 20, bottom: 20, left: 20, right: 20 },
        });
        lightbox.init();
        lightbox.loadAndOpen(index, dataSource);
      });
    },
  };
});
